import { render, staticRenderFns } from "./QResourceMenu.vue?vue&type=template&id=241203de&"
import script from "./QResourceMenu.vue?vue&type=script&lang=js&"
export * from "./QResourceMenu.vue?vue&type=script&lang=js&"
import style0 from "./QResourceMenu.vue?vue&type=style&index=0&id=241203de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports